import React, {useState, useEffect} from "react";
import Preview from '../preview';
import { useLocation } from "react-router-dom";
const DownloadInvoice = () => {
const location = useLocation();
const [invoice_data, setInvoiceData] = useState(location.state || []);
const [nextInvoice, setNextInvoice] = useState(false);
const toggleNextInvoice = () => setNextInvoice(!nextInvoice);
const [currentIndex, setCurrentIndex] = useState(0);
const [timer, setTimer] = useState(6); // 6 seconds for each download

 useEffect(() => {
    if (invoice_data.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex < invoice_data.length - 1 ? prevIndex + 1 : prevIndex
        );
        toggleNextInvoice();
      }, 6000);

      return () => clearInterval(interval);
    }
  }, [invoice_data]);

// Timer countdown effect
useEffect(() => {
  if (invoice_data.length > 0 && currentIndex < invoice_data.length - 1) {
    setTimer(6);
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdown);
  } else {
    setTimer(0);
  }
}, [currentIndex, invoice_data.length]);
  // Calculate download progress
  const totalInvoices = invoice_data.length;
  const downloaded = currentIndex + 1 > totalInvoices ? totalInvoices : currentIndex + 1;
  const remaining = totalInvoices - downloaded;
return(<>
    {/* Download progress info and timer */}
    {totalInvoices > 0 && (
      <div style={{marginBottom: '16px', textAlign: 'center', fontWeight: 'bold'}}>
        Downloaded: {downloaded} / {totalInvoices} &nbsp; | &nbsp; Remaining: {remaining}
        {remaining > 0 && timer > 0 && (
          <span style={{marginLeft: '24px', color: '#007bff'}}>
            Next download in: {timer} second{timer !== 1 ? 's' : ''}
          </span>
        )}
      </div>
    )}
    {(invoice_data && invoice_data?.length > 0)?(
        <Preview 
          key={invoice_data[currentIndex]?.invoice_no || currentIndex}
          nextInvoice={nextInvoice} 
          invoiceData={{...invoice_data[currentIndex], autoDownload : 'Y'}} 
        />
    ):(
        <h1>No Invoice Available for download</h1>
    )} 
</>);
}
export default DownloadInvoice;